import { defineStore } from "pinia";
import { onMounted } from "vue";
import { axiosInstance } from "~/plugins/axios";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: useCookie("auth_token") || null,
    refresh_token: useCookie("auth_refresh_token") || null,
    user: null as any,
  }),
  actions: {
    setToken(token: string, refresh_token: any) {
      const authToken = useCookie("auth_token");
      const authRefreshToken = useCookie("auth_refresh_token");

      this.token = token;
      this.refresh_token = refresh_token;
      authToken.value = token;
      authRefreshToken.value = refresh_token;
      this.fetchUser();
    },
    clearToken() {
      const authToken = useCookie("auth_token");
      const authRefreshToken = useCookie("auth_refresh_token");

      this.token = null;
      this.refresh_token = null;
      this.user = null;
      authToken.value = "";
      authRefreshToken.value = "";
    },
    async fetchUser() {
      if (!this.token) return;

      try {
        const response = await axiosInstance.get("/auth/me");
        this.user = response.data;
      } catch (error) {
        console.error("Failed to fetch user data:", error);
        this.clearToken();
      }
    },
    async refreshToken() {
      const config = useRuntimeConfig();

      try {
        const response = (await $fetch(
          `${config.public.apiBaseUrl}/auth/refresh`,
          {
            method: "PUT",
          }
        )) as any;

        if (response?.token) {
          this.setToken(response.token, response.refresh_token);
        } else {
          throw new Error("No token in response");
        }
      } catch (error) {
        console.error("Failed to refresh token:", error);
        this.clearToken();
        throw error;
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    userProfile: (state) => state.user,
  },
});

export function useAuthInitialization() {
  const authStore = useAuthStore();
  const authToken = useCookie("auth_token");
  const authRefreshToken = useCookie("auth_refresh_token");

  onMounted(() => {
    if (authToken?.value) {
      authStore.setToken(authToken?.value, authRefreshToken?.value);
    }
  });
}
